import React from 'react'
import { PopoverChildrenProps, Popover } from '@sketch/components'
import { ColorFormat } from '../../../../../../../Inspector/Sidebar/components/Color/utils'
import { Gradient } from '../../../../../../../../inspector'
import { GradientContent } from './GradientContent'

interface GradientPopoverProps {
  toggle: PopoverChildrenProps
  gradient: Gradient
  visible: boolean
  onColorFormatChange: (f: ColorFormat) => void
  colorFormat: ColorFormat
  hasScrollBar?: boolean
  onClickOutside?: () => void
  copyValue: string
  dropdown?: React.ReactElement
}

const GradientPopover: React.FC<GradientPopoverProps> = ({
  toggle,
  gradient,
  visible,
  onColorFormatChange,
  colorFormat,
  hasScrollBar,
  onClickOutside,
  copyValue,
  dropdown,
  ...props
}) => {
  return (
    <Popover
      visible={visible}
      placement="left"
      onClickOutside={onClickOutside}
      popup={
        <GradientContent
          copyValue={copyValue}
          onColorFormatChange={onColorFormatChange}
          colorFormat={colorFormat}
          gradient={gradient}
          onClose={onClickOutside}
        />
      }
      spacing="16px"
      data-testid="gradient-popover"
      {...props}
    >
      {toggle}
    </Popover>
  )
}

export default GradientPopover
